<template>
  <!-- <can I="edit" a="users"> -->
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-card>
          <div slot="header">
            <b-row>
              <b-col cols="6">
                <span>{{ $t('global.user_update_title') }}</span>
                <b-badge v-if="isActive === false"
                         variant="secondary" class="ml-3">
                  {{ $t('global.inactive') }}
                </b-badge>
                <b-badge v-if="isActive === true"
                         variant="success" class="ml-3">
                  {{ $t('global.active') }}
                </b-badge>
              </b-col>
              <b-col cols="6">
                <div class="pull-right">
                  <b-button v-if="isActive === false" :disabled="spinners.isChangingActive"
                            variant="success" size="sm" class="mr-1"
                            @click="changeUserActive(true)">
                    <b-spinner v-if="spinners.isChangingActive" type="grow" small/>
                    <i class="fa fa-check"/> {{ $t('global.user_activate') }}</b-button>
                  <b-button v-if="isActive === true"
                            variant="danger" size="sm" class="mr-1"
                            @click="changeUserActive(false)">
                    <b-spinner v-if="spinners.isChangingActive" type="grow" small/>
                    <i class="fa fa-ban"/> {{ $t('global.user_deactivate') }}</b-button>
                </div>
              </b-col>
            </b-row>
          </div>
          <div v-if="spinners.contentIsLoading" class="text-center">
            <b-spinner type="grow" variant="primary"/>
          </div>
          <div v-else>
            <b-row>
              <b-col cols="12" md="4">
                <b-form-group>
                  <label>{{ $t('global.name') }}</label>
                  <b-form-input type="text" :placeholder=" $t('global.name_placeholder') "
                                :class="{ 'is-invalid' : errorMsg.name }"
                                v-model="userEdit.name"/>
                  <div class="invalid-feedback" v-if="errorMsg.name">{{ errorMsg.name[0] }}</div>
                </b-form-group>

                <b-form-group>
                  <label>{{ $t('global.surname') }}</label>
                  <b-form-input type="text" :placeholder=" $t('global.surname_placeholder') "
                                :class="{ 'is-invalid' : errorMsg.surname }"
                                v-model="userEdit.surname"/>
                  <div class="invalid-feedback" v-if="errorMsg.name">{{ errorMsg.surname[0] }}</div>
                </b-form-group>

                <b-form-group>
                  <label>{{ $t('global.email') }}</label>
                  <b-form-input type="text" :placeholder=" $t('global.email_placeholder') "
                                :class="{ 'is-invalid' : errorMsg.email }"
                                v-model="userEdit.email"/>
                  <div class="invalid-feedback" v-if="errorMsg.email">{{ errorMsg.email[0] }}</div>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4">
                <b-form-group>
                  <label>{{ $t('global.roles') }}</label>
                  <treeselect :class="{ 'treeselect-error' : errorMsg.roles }"
                              :placeholder="$t('global.roles_placeholder')"
                              :multiple="true" :options="roleOptions" v-model="userEdit.roles"/>
                  <span class="error-text" v-if="errorMsg.roles">{{ errorMsg.roles[0] }}</span>
                </b-form-group>

                <b-form-group>
                  <label>{{ $t('global.extra_permissions') }}</label>
                  <treeselect :class="{ 'treeselect-error' : errorMsg.permissions }"
                              :placeholder="$t('global.permissions_placeholder')"
                              :multiple="true" :options="permissionsOptions" v-model="userEdit.permissions"/>
                  <span class="error-text" v-if="errorMsg.permissions">{{ errorMsg.permissions[0] }}</span>
                </b-form-group>
              </b-col>
                <b-col cols="12" md="4" class="split-line">
                  <h5>{{ $t('global.user_update_change_password') }}</h5>
                  <b-form-group>
                    <label>{{ $t('global.password') }}</label>
                    <b-form-input type="password"
                                  :placeholder=" $t('global.password_placeholder') "
                                  :class="{ 'is-invalid' : errorMsg.password }"
                                  v-model="userEdit.password"/>
                    <div class="invalid-feedback" v-if="errorMsg.password">{{ errorMsg.password[0] }}</div>
                </b-form-group>

                <b-form-group>
                  <label>{{ $t('global.password_repeat') }}</label>
                  <b-form-input type="password"
                                :placeholder=" $t('global.password_repeat_placeholder') "
                                :class="{ 'is-invalid' : errorMsg.password }"
                                v-model="userEdit.password_confirmation"/>
                  <div class="invalid-feedback" v-if="errorMsg.password">{{ errorMsg.password[0] }}</div>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <div slot="footer">
            <b-button type="submit" variant="primary" :disabled="spinners.isSaving" @click="onSave()">
              <b-spinner v-if="spinners.isSaving" type="grow" small/>
              {{ $t('global.save') }}
            </b-button>
            <router-link :to="{ name: 'Users'}">
              <b-button type="reset" variant="info" class="ml-2">
                {{ $t('global.cancel') }}
              </b-button>
            </router-link>
          </div>
        </b-card>
      </div>
    </div>
  <!-- </can> -->
</template>

<script>
import statuses from '@/store/statuses';
import forEach from 'lodash.foreach';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { mapGetters, mapActions } from 'vuex';
import VT from '@/store/types';

export default {
  mounted() {
    this.getData();
  },
  data() {
    return {
      spinners: {
        contentIsLoading: true,
        isSaving: false,
        isChangingActive: false
      },
      isActive: null,
      userEdit: {
        name: '',
        surname: '',
        email: '',
        roles: [],
        permissions: [],
        current_password: null,
        password: null,
        password_confirmation: null,
      },
      roleOptions: [],
      permissionsOptions: [],
      errorMsg: {}
    };
  },
  components: {
    Treeselect
  },
  computed: {
    ...mapGetters('Users', [
      'userUpdateData',
      'userUpdate',
      'userUpdateActive',
    ]),
  },
  watch: {
    userUpdateData: {
      handler: function () {
        if (this.userUpdateData.status === statuses.LOADED) {
          this.fillData();
          this.spinners.contentIsLoading = false;
        }
      },
      deep: true
    },
    userUpdate: {
      handler: function () {
        this.errorMsg = {};
        this.spinners.isSaving = false;
        if (this.userUpdate.status === statuses.LOADED) {
          this.alertSuccess();
          this.getData();
        } else if (this.userUpdate.status === statuses.ERROR) {
          this.alertError();
          this.errorMsg = this.userUpdate.data.data.errors;
        }
      },
      deep: true
    },
    userUpdateActive: {
      handler: function () {
        this.spinners.isChangingActive = false;
        if (this.userUpdateActive.status === statuses.LOADED) {
          this.alertSuccess();
          this.getData();
        } else if (this.userUpdateActive.status === statuses.ERROR) {
          this.alertError();
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Users', [
      VT.USER_UPDATE_DATA,
      VT.USER_UPDATE,
      VT.USER_UPDATE_ACTIVE,
    ]),
    getData() {
      this.USER_UPDATE_DATA(this.$route.params.id);
    },
    fillData() {
      const user = JSON.parse(JSON.stringify(this.userUpdateData.data.user));
      const roles = JSON.parse(JSON.stringify(this.userUpdateData.data.roles));

      const disabledPermissions = [];
      this.isActive = user['is_active'];

      this.userEdit = {
        name: user['name'],
        surname: user['surname'],
        email: user['email'],
        roles: [],
        permissions: []
      };

      const userRoles = [];
      if (user.roles.length) {
        forEach(user.roles, (role) => {
          userRoles.push(role['id']);

          if (role.permissions.length) {
            forEach(role.permissions, (permission) => {
              if (!disabledPermissions.includes(permission['id'])) {
                disabledPermissions.push(permission['id']);
              }
            });
          }
        });
        this.userEdit.roles = userRoles;
      }

      const userPermissions = [];
      if (user.permissions.length) {
        forEach(user.permissions, (permission) => {
          userPermissions.push(permission['id']);
        });
        this.userEdit.permissions = userPermissions;
      }
      this.fillRolesOptions(roles);
      this.fillPermissionsOptions(
        JSON.parse(JSON.stringify(this.userUpdateData.data.permissions)),
        disabledPermissions
      );
    },
    fillRolesOptions(roles) {
      const rolesOpt = [];
      forEach(roles, (role) => {
        rolesOpt.push({
          id: role['id'],
          label: this.$t(role['name'], 'global')
        });
      });
      this.roleOptions = rolesOpt;
    },
    fillPermissionsOptions(permissions, disabledPermissions) {
      const permissionsOpt = [];
      forEach(permissions, (permission) => {
        let isDisabled = false;

        if (disabledPermissions.includes(permission['id'])) {
          isDisabled = true;
        }
        permissionsOpt.push({
          id: permission['id'],
          label: permission['name'],
          isDisabled: isDisabled
        });
      });
      this.permissionsOptions = permissionsOpt;
    },
    onSave() {
      this.spinners.isSaving = true;
      this.USER_UPDATE({ id: this.$route.params.id, update: this.userEdit });
    },
    changeUserActive(isActive) {
      this.spinners.isChangingActive = true;
      this.USER_UPDATE_ACTIVE({ id: this.$route.params.id, isActive });
    }
  }
};
</script>

<style scoped>
@media screen and (min-width: 768px) {
  .split-line {
      border-left: 1px solid lightgrey;
  }
}
@media screen and (max-width: 767px) {
  .split-line {
      border-top: 1px solid lightgrey;
      margin-top: 20px;
      padding-top: 20px;
  }
}
</style>
